import { useEffect, useState } from 'react';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import villaLogo from './assets/Navbar/CINNAMON MANTRA (1).png';
import heroVillaImage from './assets/photos/1.png';
import heroGardenImage from './assets/photos/IMG_4694.webp';
import heroRoomImage from './assets/New Photos/IMG_3595.webp';
import heroAyurvedaImage from './assets/8.jpeg';
import heroRetreatImage from './assets/Ayurveda/5.jpeg';
import aboutVillaImage from './assets/Ayurveda/WhatsApp Image 2025-12-05 at 11.23.34.jpeg';
import aboutGardenImage from './assets/photos/IMG_4675.webp';
import aboutStayImage from './assets/New Photos/IMG_3634.webp';
import aboutNatureImage from './assets/New Photos/IMG_2436.webp';
import foodImage from './assets/photos/IMG_4681.webp';
import roomImageOne from './assets/Hotel/DSC_0500.JPG';
import roomImageTwo from './assets/Hotel/DSC_0543.JPG';
import roomImageThree from './assets/Hotel/19.jpeg';
import roomImageFour from './assets/Hotel/DSC_0551.JPG';
import roomImageFive from './assets/Hotel/DSC_0568.JPG';
import retreatImage from './assets/Gallery/DSC_0695.JPG';

const treatments = [
  { english: 'Head Massage', japanese: 'ヘッドマッサージ' },
  { english: 'Foot Massage', japanese: 'フットマッサージ' },
  { english: 'Face Massage', japanese: 'フェイスマッサージ' },
  { english: 'Full Body Massage', japanese: '全身マッサージ' },
  { english: 'Intensive Massage', japanese: '集中マッサージ' },
  { english: 'Acupuncture', japanese: '鍼治療' },
  { english: 'Nasal Cleaning', japanese: '鼻洗浄' },
  { english: 'Steam Bath', japanese: 'スチームバス' },
  { english: 'Synchron Massage', japanese: 'シンクロナイズドマッサージ' },
  { english: 'Shirodhara', japanese: 'シロダーラ' },
  { english: 'Special Massage', japanese: 'スペシャルマッサージ' },
  { english: 'Flower Bath', japanese: 'フラワーバス', note: '最終日にご用意' },
  { english: 'Herbal Bath', japanese: 'ハーバルバス' },
];

const packageInclusions = [
  { count: '03 回', title: '鍼治療', detail: '専門家との相談に基づく施術' },
  { count: '04 回', title: 'ヨガ', detail: '呼吸と動きを整えるクラス' },
  { count: '毎日', title: '施術', detail: '1日約2時間を目安にご案内' },
  { count: '滞在中', title: '瞑想セッション', detail: '自分の内側に向き合う静かな時間' },
  { count: '01 回', title: '料理教室', detail: 'スリランカの家庭料理を体験' },
  { count: '毎食', title: 'スパイス料理', detail: '旬の食材と香り豊かなスパイス' },
];

const heroSlides = [
  { image: heroVillaImage, alt: '緑に囲まれたヴィラ' },
  { image: heroGardenImage, alt: 'ヴィラと周囲の自然を望む景色' },
  { image: heroRoomImage, alt: 'スリランカのヴィラの客室' },
  { image: heroAyurvedaImage, alt: 'アーユルヴェーダのある滞在' },
  { image: heroRetreatImage, alt: '自然に包まれたリトリート' },
];

const aboutSlides = [
  { image: aboutVillaImage, alt: 'ヴィラの外観' },
  { image: aboutGardenImage, alt: 'ヴィラの緑豊かな庭' },
  { image: aboutStayImage, alt: 'ヴィラで過ごす穏やかな時間' },
  { image: aboutNatureImage, alt: 'スリランカの自然の風景' },
];

const roomSlides = [
  { image: roomImageOne, alt: 'デラックス・ダブルルームのベッドルーム' },
  { image: roomImageTwo, alt: 'デラックス・ダブルルームの室内' },
  { image: roomImageThree, alt: '落ち着いた客室のインテリア' },
  { image: roomImageFour, alt: '客室でくつろげるシーティングエリア' },
  { image: roomImageFive, alt: 'デラックス・ダブルルームのベッド' },
];

function useAutoAdvance(slideCount, interval) {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const slideTimer = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slideCount);
    }, interval);

    return () => window.clearInterval(slideTimer);
  }, [interval, slideCount]);

  return [activeSlide, setActiveSlide];
}

function App() {
  const [activeSlide] = useAutoAdvance(heroSlides.length, 6000);
  const [activeAboutSlide] = useAutoAdvance(aboutSlides.length, 5000);
  const [activeRoomSlide] = useAutoAdvance(roomSlides.length, 5000);

  return (
    <div className="overflow-x-clip">
      <header className="flex min-h-[72px] items-center justify-between gap-3 bg-white px-4 py-3 sm:min-h-[82px] sm:px-[7vw]">
        <div className="inline-flex min-w-0 items-center gap-2 text-green-deep sm:gap-3" aria-label="Cinnamon Mantra Ayurveda Villa">
          <img className="h-9 w-10 shrink-0 object-contain sm:h-12 sm:w-14" src={villaLogo} alt="" />
          <span className="flex min-w-0 flex-col gap-[3px]">
            <strong className="truncate font-serif text-sm font-medium tracking-[.01em] sm:text-[19px]">Cinnamon Mantra</strong>
            <span className="whitespace-nowrap text-[7px] tracking-[.12em] text-[#777d70] sm:text-[9px] sm:tracking-[.15em]">AYURVEDA VILLA · SRI LANKA</span>
          </span>
        </div>
        <span className="shrink-0 text-right text-[8px] tracking-[.08em] text-[#777d70] sm:text-[9px] sm:tracking-[.15em]">スリランカ・モラガラ</span>
      </header>

      <main>
        <section className="relative flex min-h-[min(620px,calc(100svh-72px))] items-center overflow-hidden bg-[#526a47] text-white sm:min-h-[min(720px,78vw)]" aria-labelledby="hero-title">
          {heroSlides.map((slide, index) => (
            <img
              key={slide.image}
              className={`absolute inset-0 h-full w-full object-cover object-[61%_center] transition-opacity duration-1000 sm:object-[center_55%] ${activeSlide === index ? 'opacity-100' : 'opacity-0'
                }`}
              src={slide.image}
              alt={activeSlide === index ? slide.alt : ''}
              aria-hidden={activeSlide !== index}
              fetchPriority={index === 0 ? 'high' : 'auto'}
            />
          ))}
          <div className="absolute inset-0 bg-gradient-to-r from-[rgba(20,42,27,0.77)] via-[rgba(23,48,31,0.46)] to-[rgba(23,48,31,0.05)] max-sm:from-[rgba(20,42,27,0.76)] max-sm:via-[rgba(23,48,31,0.5)] max-sm:to-[rgba(23,48,31,0.3)]" />
          <div className="relative z-10 mx-auto w-full max-w-[1440px] px-5 py-20 sm:px-[10vw] sm:py-[105px]">
            <h1 id="hero-title" className="m-0 text-[clamp(34px,8vw,51px)] font-medium leading-[1.58] tracking-[.07em] sm:text-[clamp(37px,5.2vw,68px)]">自然に還り、<br />心と身体を整える。</h1>
            <p className="mt-[25px] text-[clamp(14px,1.25vw,17px)] leading-[2.15] tracking-[.06em] text-white/90">
              スリランカの緑と伝統に包まれて。<br />
              あなたのための、アーユルヴェーダ・リトリート。
            </p>
            <span className="mt-10 inline-block border-t border-white/50 pt-3 text-[9px] tracking-[.21em]">CINNAMON MANTRA AYURVEDA VILLA</span>
          </div>
          <span className="absolute bottom-[34px] right-[5vw] hidden rotate-90 text-[9px] tracking-[.2em] [transform-origin:right_bottom] sm:block" aria-hidden="true">スリランカのウェルネスリトリート</span>
          <div className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2" aria-label={`スライド ${activeSlide + 1} / ${heroSlides.length}`}>
            {heroSlides.map((slide, index) => (
              <span
                key={slide.image}
                className={`h-[3px] w-6 rounded-full transition-colors duration-500 ${activeSlide === index ? 'bg-white' : 'bg-white/45'
                  }`}
              />
            ))}
          </div>
        </section>

        {/*about*/}
        <section className="mx-auto grid max-w-[1240px] grid-cols-1 gap-y-6 px-5 py-16 sm:px-[7vw] sm:py-[110px] lg:grid-cols-[1fr_.88fr] lg:items-center lg:gap-x-[8vw] lg:gap-y-6 lg:py-[136px]" aria-labelledby="about-title">
          <div className="lg:col-start-1 lg:row-start-1">
            <p className="mb-[22px] text-[10px] font-semibold uppercase tracking-[.2em] text-pear-deep">ヴィラについて</p>
            <h2 id="about-title" className="m-0 text-[clamp(27px,3.3vw,42px)] font-medium leading-[1.75] tracking-[.07em] text-green-deep">自分をいたわる時間を、<br />緑豊かなヴィラで。</h2>
          </div>
          <div className="relative aspect-[1.15/1] overflow-hidden sm:aspect-[4/4.6] lg:col-start-2 lg:row-span-2 lg:row-start-1" aria-label="ヴィラの写真">
            {aboutSlides.map((slide, index) => (
              <img
                key={slide.image}
                className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ${activeAboutSlide === index ? 'opacity-100' : 'opacity-0'
                  }`}
                src={slide.image}
                alt={activeAboutSlide === index ? slide.alt : ''}
                aria-hidden={activeAboutSlide !== index}
                loading="eager"
              />
            ))}
          </div>
          <div className="lg:col-start-1 lg:row-start-2">
            <p className="mt-[25px] text-[14px] leading-[2.25] tracking-[.025em] text-[#6c7068]">
              Cinnamon Mantra Ayurveda Villa は、スリランカの穏やかな自然の中で、
              アーユルヴェーダの知恵に触れる小さなリトリートです。
              お一人おひとりの体調や気分を大切にしながら、施術、ヨガ、食事、休息を通して
              日々のリズムを見つめ直すひとときをお届けします。
            </p>
            <div className="mt-[34px] flex items-center gap-[13px] text-[12px] tracking-[.08em] text-green-deep">
              <span className="h-px w-[38px] bg-pear" />
              <span>ゆっくりと、自分のペースで。</span>
            </div>
          </div>
        </section>

        {/*ayurveda*/}
        <section className="bg-green-deep px-5 py-16 text-center text-white sm:px-6 sm:py-[90px] lg:py-[105px]" aria-labelledby="ayurveda-title">
          <div className="mx-auto max-w-[870px]">
            <p className="mb-[22px] text-[10px] font-semibold uppercase tracking-[.2em] text-[#c4d69e]">アーユルヴェーダの考え方</p>
            <h2 id="ayurveda-title" className="m-0 text-[clamp(27px,3.3vw,40px)] font-medium tracking-[.1em]">アーユルヴェーダのある暮らし</h2>
            <p className="mx-auto mt-[22px] max-w-[700px] text-[14px] leading-[2.2] text-white/80">
              アーユルヴェーダは、食事や休息、季節との調和を大切にする伝統的な健康の知恵。
              決まった形を押しつけるのではなく、今のあなたに合う心地よさを一緒に探します。
            </p>
            <div className="mt-[38px] grid grid-cols-1 gap-5 border-t border-white/20 pt-[27px] sm:mt-14 sm:grid-cols-3 sm:gap-0" aria-label="大切にしていること">
              <div className="flex flex-col gap-[10px] pb-[17px] sm:px-3 sm:pb-0"><span className="font-serif text-[13px] text-[#c4d69e]">01</span><strong className="text-[13px] font-medium tracking-[.06em]">個別のカウンセリング</strong><small className="text-[10px] tracking-[.03em] text-white/65">体調やご希望を丁寧に伺います</small></div>
              <div className="flex flex-col gap-[10px] border-t border-white/20 pt-[17px] sm:border-l sm:border-t-0 sm:px-3 sm:pt-0"><span className="font-serif text-[13px] text-[#c4d69e]">02</span><strong className="text-[13px] font-medium tracking-[.06em]">自然に寄り添う施術</strong><small className="text-[10px] tracking-[.03em] text-white/65">一人ひとりに合わせたケア</small></div>
              <div className="flex flex-col gap-[10px] border-t border-white/20 pt-[17px] sm:border-l sm:border-t-0 sm:px-3 sm:pt-0"><span className="font-serif text-[13px] text-[#c4d69e]">03</span><strong className="text-[13px] font-medium tracking-[.06em]">食と休息のバランス</strong><small className="text-[10px] tracking-[.03em] text-white/65">毎日の過ごし方から整える</small></div>
            </div>
          </div>
        </section>

        {/*treatments*/}
        <section className="mx-auto max-w-[1240px] px-5 py-16 sm:px-[7vw] sm:py-[100px] lg:py-[130px]" aria-labelledby="treatments-title">
          <div className="mb-8 flex flex-col items-start justify-between gap-4 sm:mb-[42px] sm:flex-row sm:items-end sm:gap-8">
            <div>
              <p className="mb-3 text-[10px] font-semibold uppercase tracking-[.2em] text-pear-deep">アーユルヴェーダの施術</p>
              <h2 id="treatments-title" className="m-0 text-[clamp(27px,3.3vw,42px)] font-medium leading-[1.75] tracking-[.07em] text-green-deep">伝統の手当てで、深い休息へ。</h2>
            </div>
            <p className="m-0 max-w-[360px] text-[11px] leading-[1.8] tracking-[.04em] text-[#777d70] sm:text-right">施術内容は事前のカウンセリングをもとにご案内します。</p>
          </div>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {treatments.map((treatment, index) => (
              <article className="flex min-h-[116px] items-start gap-4 rounded-sm bg-[#f7f8f2] px-5 py-5 sm:px-6" key={treatment.english}>
                <span className="mt-1 font-serif text-xs tracking-[.08em] text-pear-deep">{String(index + 1).padStart(2, '0')}</span>
                <div>
                  <h3 className="m-0 text-base font-medium tracking-[.03em] text-green-deep">{treatment.english}</h3>
                  <p className="mb-0 mt-2 text-sm tracking-[.04em] text-[#767a71]">{treatment.japanese}</p>
                  {treatment.note && <span className="mt-2 inline-block rounded-full bg-[#eaf0dd] px-3 py-1 text-[10px] tracking-[.03em] text-pear-deep">{treatment.note}</span>}
                </div>
              </article>
            ))}
          </div>
        </section>

        {/*food*/}
        <section className="grid grid-cols-1 items-stretch bg-[#f3f5eb] lg:grid-cols-2 lg:items-center" aria-labelledby="food-title">
          <div className="mx-auto w-full max-w-[610px] px-5 pb-6 pt-12 sm:px-10 sm:pt-16 lg:col-start-1 lg:row-start-1 lg:px-12 lg:pb-2 lg:pt-16 xl:px-16">
            <p className="mb-4 text-[10px] font-semibold uppercase tracking-[.2em] text-pear-deep">食事とスパイス</p>
            <h2 id="food-title" className="m-0 text-[clamp(29px,3.5vw,44px)] font-medium leading-[1.75] tracking-[.07em] text-green-deep">食べることから、<br />健やかに。</h2>
          </div>
          <div className="overflow-hidden lg:col-start-2 lg:row-span-2 lg:row-start-1">
            <img className="aspect-[4/3] w-full object-cover lg:aspect-auto lg:h-full lg:min-h-[420px] xl:min-h-[520px]" src={foodImage} alt="スパイスを使ったスリランカ料理" loading="lazy" />
          </div>
          <div className="mx-auto w-full max-w-[610px] self-center px-5 pb-12 pt-6 sm:px-10 sm:pb-16 lg:col-start-1 lg:row-start-2 lg:px-12 lg:pb-16 lg:pt-2 xl:px-16">
            <p className="mt-[25px] text-[14px] leading-[2.25] tracking-[.025em] text-[#6c7068]">
              新鮮な食材に、シナモンやターメリックなどの香り豊かなスパイスを添えて。
              身体にやさしいスリランカの料理を味わい、食卓から土地の文化に触れてみませんか。
            </p>
            <div className="mt-[27px] flex flex-wrap gap-[9px]">
              <span className="rounded-[30px] border border-[#d5dfc3] px-[13px] py-[9px] text-[10px] tracking-[.04em] text-[#5d713d]">旬の食材</span><span className="rounded-[30px] border border-[#d5dfc3] px-[13px] py-[9px] text-[10px] tracking-[.04em] text-[#5d713d]">香り豊かなスパイス</span><span className="rounded-[30px] border border-[#d5dfc3] px-[13px] py-[9px] text-[10px] tracking-[.04em] text-[#5d713d]">料理体験</span>
            </div>
          </div>
        </section>

        {/*package*/}
        <section className="mx-auto max-w-[1240px] px-5 py-16 sm:px-[7vw] sm:py-[100px] lg:py-[126px]" aria-labelledby="package-title">
          <div className="mx-auto mb-9 max-w-[760px] text-center sm:mb-[52px]">
            <p className="mb-3 text-[10px] font-semibold uppercase tracking-[.2em] text-pear-deep">7日間のリトリート</p>
            <h2 id="package-title" className="m-0 text-[clamp(27px,3.3vw,42px)] font-medium leading-[1.75] tracking-[.07em] text-green-deep">7日間のアーユルヴェーダ・プラン</h2>
            <p className="mt-[14px] text-[13px] leading-[1.9] tracking-[.03em] text-[#777d70]">施術、ヨガ、瞑想、食を組み合わせた、心と身体を見つめる7日間。</p>
          </div>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {packageInclusions.map((item) => (
              <article className="min-h-[120px] rounded-sm bg-[#f7f8f2] px-5 py-5 sm:min-h-[144px] sm:px-6 sm:py-6" key={item.title}>
                <span className="font-serif text-xs tracking-[.08em] text-pear-deep">{item.count}</span>
                <h3 className="mb-[5px] mt-3 text-[17px] font-medium tracking-[.05em] text-green-deep">{item.title}</h3>
                <p className="m-0 text-[11px] leading-[1.8] text-[#777d70]">{item.detail}</p>
              </article>
            ))}
          </div>
          <p className="mb-10 mt-5 text-[10px] leading-[1.9] text-[#83877d] sm:mb-[70px] sm:text-[11px]">
            ※ 施術は1日約2時間を目安とし、内容・時間は体調や専門家の判断により調整します。
          </p>
        </section>

        {/*rooms*/}
        <section className="mb-16 grid bg-[#f3f5eb] lg:mb-24 lg:grid-cols-2 lg:items-center" aria-labelledby="rooms-title">
          <div className="px-5 pb-5 pt-12 sm:px-12 sm:pt-16 lg:col-start-2 lg:row-start-1 lg:px-12 lg:pb-0 lg:pt-16 xl:px-16">
            <p className="mb-4 text-[10px] font-semibold uppercase tracking-[.2em] text-pear-deep">ROOMS · ご宿泊</p>
            <h2 id="rooms-title" className="m-0 text-[clamp(28px,3.5vw,44px)] font-medium leading-[1.55] tracking-[.04em] text-green-deep">
              デラックスダブルルーム
            </h2>
          </div>
          <div className="relative order-2 aspect-[4/3] overflow-hidden sm:aspect-[16/10] lg:order-none lg:col-start-1 lg:row-span-2 lg:row-start-1 lg:aspect-auto lg:min-h-[500px]">
            {roomSlides.map((slide, index) => (
              <img
                key={slide.image}
                className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ${activeRoomSlide === index ? 'opacity-100' : 'opacity-0'
                  }`}
                src={slide.image}
                alt={activeRoomSlide === index ? slide.alt : ''}
                aria-hidden={activeRoomSlide !== index}
                loading="eager"
              />
            ))}
            <div className="absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2" aria-label={`客室写真 ${activeRoomSlide + 1} / ${roomSlides.length}`}>
              {roomSlides.map((slide, index) => (
                <span
                  key={slide.image}
                  className={`h-[3px] w-6 rounded-full transition-colors duration-500 ${activeRoomSlide === index ? 'bg-white' : 'bg-white/55'
                    }`}
                />
              ))}
            </div>
          </div>
          <div className="order-3 mx-auto flex w-full max-w-[620px] flex-col justify-center px-5 pb-12 pt-5 sm:px-12 sm:pb-16 lg:order-none lg:col-start-2 lg:row-start-2 lg:px-12 lg:pb-16 lg:pt-3 xl:px-16">
            <p className="mb-0 mt-3 text-lg tracking-[.08em] text-pear-deep">デラックス・ダブルルーム</p>
            <p className="mb-0 mt-6 text-sm leading-[2.2] tracking-[.025em] text-[#6c7068]">
              アーユルヴェーダの滞在をゆったりと過ごすための、落ち着いたダブルルーム。
              一日の施術やヨガのあとに、心身を休めるプライベートな空間をご用意しています。
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <span className="rounded-full border border-[#d5dfc3] px-4 py-2 text-xs tracking-[.04em] text-[#5d713d]">ダブルベッド</span>
              <span className="rounded-full border border-[#d5dfc3] px-4 py-2 text-xs tracking-[.04em] text-[#5d713d]">プライベート空間</span>
              <span className="rounded-full border border-[#d5dfc3] px-4 py-2 text-xs tracking-[.04em] text-[#5d713d]">静かな休息</span>
            </div>
          </div>
        </section>

        {/*retreat*/}
        <section className="relative flex min-h-[340px] items-center overflow-hidden text-white sm:min-h-[410px]" aria-label="リトリートのメッセージ">
          <img className="absolute inset-0 h-full w-full object-cover object-[center_48%]" src={retreatImage} alt="自然の中で心を整えるヨガ" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-r from-[rgba(25,48,31,0.78)] to-[rgba(25,48,31,0.22)]" />
          <div className="relative mx-auto w-full max-w-[1240px] px-5 py-[65px] sm:px-[7vw] sm:py-20">
            <p className="mb-[22px] text-[10px] font-semibold uppercase tracking-[.2em] text-[#dce8c6]">あなたのためのひととき</p>
            <h2 className="m-0 text-[clamp(31px,4vw,50px)] font-medium leading-[1.65] tracking-[.1em]">深呼吸から、<br />新しい自分へ。</h2>
            <p className="mt-[15px] text-[13px] tracking-[.06em] text-white/80">自然に身をゆだねる、スリランカでの穏やかな滞在。</p>
          </div>
        </section>

        <section className="mx-auto max-w-[1240px] px-5 py-14 sm:px-[7vw] sm:py-24" aria-labelledby="location-title">
          <div className="mb-8 text-center">
            <p className="mb-3 text-[10px] font-semibold uppercase tracking-[.2em] text-pear-deep">LOCATION · アクセス</p>
            <h2 id="location-title" className="m-0 break-words text-[clamp(24px,3.3vw,42px)] font-medium tracking-[.04em] text-green-deep sm:tracking-[.07em]">
              Cinnamon Mantra Ayurveda Villa
            </h2>
            <p className="mb-0 mt-3 text-sm tracking-[.08em] text-[#777d70]">スリランカ・モラガラ</p>
          </div>
          <iframe
            className="h-[300px] w-full rounded-sm border-0 sm:h-[400px] lg:h-[450px]"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4191.677866130044!2d79.97955739999999!3d6.4527119!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae22f0add05e4db%3A0x238f0c1bdab0b548!2sCinnamon%20Mantra%20Ayurveda%20Wellness%20Center%20%26%20Ayurveda%20Villa!5e1!3m2!1sen!2slk!4v1792405585488!5m2!1sen!2slk"
            title="Cinnamon Mantra Ayurveda Villa の地図"
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </section>
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;
